import React, { lazy } from 'react';
import { motion } from 'framer-motion';
export function ProjectCarousel() {
  const projectImages = [{
    src: 'https://cdn.magicpatterns.com/uploads/tYuVb9HTydAA7UQEFamLmW/imagen_1.jpg',
    alt: 'Mesa infinita LED azul con marco negro'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/kkHa6ZqiMeP4LA5kLmEwUF/imagen_2.jpg',
    alt: 'Mesa hexagonal con jardín infinito'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/xsoiFimvgt1H5pGga13mM8/imagen_3.jpg',
    alt: 'Mesa de audio con ondas LED multicolor'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/5trK8LhykvavzJv5XzV3ZZ/imagen_4.jpg',
    alt: 'Escritorio gamer con LED RGB multicolor'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/7zStxgqYSVtvjYBqRdPn5Y/imagen_5.jpg',
    alt: 'Mesa hexagonal con panal de abeja LED'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/okBmQztkFXCPnv1Uxt9zuW/imagen_6.jpg',
    alt: 'Escritorio gaming LED con setup completo'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/qWrihL8PhspocJNjAFa4tZ/imagen_7.jpg',
    alt: 'Mesas altas LED para bar o restaurante'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/7f3BJauSnevteJ23mEZbSC/imagen_8.jpg',
    alt: 'Mesa redonda LED con patas de madera'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/xeZndR8wcQcFbCoJ7BPfF9/imagen_9.jpg',
    alt: 'Mesa infinita LED multicolor con efecto de puntos'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/3sLfM1yBdJz67rrt1eettm/imagen_10.jpg',
    alt: 'Mesa infinita con efecto galaxia espacial'
  }];
  // Duplicate the array to create a seamless infinite loop
  const duplicatedImages = [...projectImages, ...projectImages];
  return <section className="py-20 px-4 relative z-10 bg-[#121212] overflow-hidden border-y border-[#27272a]" data-id="element-250">
      <style data-id="element-251">
        {`
          @keyframes scroll {
            0% { transform: translateX(0); }
            100% { transform: translateX(-50%); }
          }
          .animate-scroll {
            animation: scroll 50s linear infinite;
          }
          .animate-scroll:hover {
            animation-play-state: paused;
          }
        `}
      </style>

      <div className="max-w-7xl mx-auto" data-id="element-252">
        <div className="text-center mb-12" data-id="element-253">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-[#18181b] border border-[#27272a] text-[#dc2626] text-sm font-bold mb-6 tracking-wide" data-id="element-254">
            ✨ PROYECTOS REALES
          </motion.div>

          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl lg:text-5xl font-black text-white mb-4 tracking-tight leading-[1.1] uppercase" data-id="element-255">
            INSPIRACIÓN INFINITA
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-lg text-gray-400 max-w-2xl mx-auto font-medium" data-id="element-256">
            Mirá lo que podés crear con las técnicas del ebook
          </motion.p>
        </div>

        {/* Marquee Container */}
        <div className="relative w-full overflow-hidden py-8" data-id="element-257">
          {/* Left and Right fade gradients for smooth edges */}
          <div className="absolute left-0 top-0 bottom-0 w-24 md:w-48 bg-gradient-to-r from-[#121212] to-transparent z-10 pointer-events-none" data-id="element-258" />
          <div className="absolute right-0 top-0 bottom-0 w-24 md:w-48 bg-gradient-to-l from-[#121212] to-transparent z-10 pointer-events-none" data-id="element-259" />

          {/* Scrolling Track */}
          <div className="flex w-max animate-scroll gap-6 px-4" data-id="element-260">
            {duplicatedImages.map((image, index) => <div key={index} className="w-80 md:w-96 h-64 md:h-72 shrink-0 transition-transform duration-500 hover:scale-105 hover:z-20 cursor-pointer group" data-id="element-261">
                <div className="relative w-full h-full overflow-hidden rounded-2xl shadow-[0_10px_40px_rgba(220,38,38,0.3)] border border-red-900/20 group-hover:border-red-500/40 transition-colors" data-id="element-262">
                  <img src={image.src} alt={image.alt} className="w-full h-full object-cover" loading="lazy" data-id="element-263" />
                  {/* Overlay on hover */}
                  <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/30 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-6" data-id="element-264">
                    <p className="text-white font-bold text-base" data-id="element-265">
                      {image.alt}
                    </p>
                  </div>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}